// // import React, { useState } from 'react';
// // import { Outlet, useNavigate, useLocation } from 'react-router-dom';
// // import {
// //   Box,
// //   Drawer,
// //   AppBar,
// //   Toolbar,
// //   List,
// //   Typography,
// //   Divider,
// //   IconButton,
// //   ListItem,
// //   ListItemButton,
// //   ListItemIcon,
// //   ListItemText,
// //   Avatar,
// //   Menu,
// //   MenuItem,
// // } from '@mui/material';
// // import {
// //   Menu as MenuIcon,
// //   Dashboard,
// //   DirectionsCar,
// //   People,
// //   LocalTaxi,
// //   VerifiedUser,
// //   Payment,
// //   MonetizationOn,
// //   LocalOffer,
// //   AttachMoney,
// //   Notifications,
// //   Assessment,
// //   Warning,
// //   TrackChanges,
// //   Star,
// //   Support,
// //   Settings,
// //   LocationOn,
// //   Build,
// //   Category,
// //   Report,
// //   SupervisorAccount,
// //   Logout,
// //   Description,
// //   Cancel,
// //   QuestionAnswer,
// //   Gavel,
// //   CurrencyRupee,
// //   History,
// //   ContactPhone,
// //   Chat,
// //   Forum,
// //   Language,
// //   ExpandLess,
// //   ExpandMore,
// // } from '@mui/icons-material';
// // import { useAuth } from '../context/AuthContext';

// // const drawerWidth = 260;

// // const menuItems = [
// //   { text: 'Dashboard', icon: <Dashboard />, path: '/dashboard' },
// //   { text: 'Earnings', icon: <Dashboard />, path: '/earnings' },
// //   { text: 'Driver Recharge History', icon: <Dashboard />, path: '/driver-recharge-history' },
// //   // {
// //   //   text: 'Dashboard',
// //   //   icon: <Dashboard />,
// //   //   children: [
// //   //     {
// //   //       text: 'Dashboard',
// //   //       path: '/dashboard',
// //   //       icon: <Dashboard />,
// //   //     },
// //   //     {
// //   //       text: 'Earnings',
// //   //       path: '/dashboard/earnings',
// //   //       icon: <AttachMoney />,
// //   //     },
// //   //     {
// //   //       text: 'Recharge History',
// //   //       path: '/dashboard/recharge-history',
// //   //       icon: <History />,
// //   //     },
// //   //   ],
// //   // },

// //   { text: 'Drivers', icon: <DirectionsCar />, path: '/drivers' },
// //   { text: 'Manage Driver Documents', icon: <Description />, path: '/driver-documents' },
// //   { text: 'Passengers', icon: <People />, path: '/passengers' },
// //   { text: 'Rides', icon: <LocalTaxi />, path: '/rides' },
// //   { text: 'Verifications', icon: <VerifiedUser />, path: '/verifications' },
// //   { text: 'Documents', icon: <Description />, path: '/documents' },
// //   // Transactions and Withdrawals temporarily hidden — recharge model collects
// //   // cash directly from passenger to driver, so platform doesn't track per-ride
// //   // transactions or driver withdrawals. Routes still exist (see App.js) so
// //   // direct URLs work; uncomment these lines to re-add to the sidebar.
// //   // { text: 'Transactions', icon: <Payment />, path: '/transactions' },
// //   // { text: 'Withdrawals', icon: <MonetizationOn />, path: '/withdrawals' },
// //   { text: 'Promo Codes', icon: <LocalOffer />, path: '/promo-codes' },
// //   { text: 'Pricing', icon: <AttachMoney />, path: '/pricing' },
// //   { text: 'Notifications', icon: <Notifications />, path: '/notifications' },
// //   { text: 'Notification History', icon: <History />, path: '/notification-history' },
// //   { text: 'Emergency Contacts', icon: <ContactPhone />, path: '/emergency-contacts' },
// //   { text: 'Reports', icon: <Assessment />, path: '/reports' },
// //   { text: 'Emergency', icon: <Warning />, path: '/emergency' },
// //   { text: 'Live Tracking', icon: <TrackChanges />, path: '/live-tracking' },
// //   { text: 'Ratings', icon: <Star />, path: '/ratings' },
// //   { text: 'Support', icon: <Support />, path: '/support' },
// //   { text: 'Regions', icon: <LocationOn />, path: '/regions' },
// //   { text: 'Main Services', icon: <Category />, path: '/main-services' },
// //   { text: 'Services', icon: <Build />, path: '/services' },
// //   { text: 'Manage Cancel Reasons', icon: <Cancel />, path: '/cancel-reasons' },
// //   { text: 'Manage Ratings', icon: <Star />, path: '/rating-feedback' },
// //   { text: 'Manage Quick Chat', icon: <Chat />, path: '/quick-chat' },
// //   { text: 'Chat Conversations', icon: <Forum />, path: '/chat-conversations' },
// //   { text: 'FAQs', icon: <QuestionAnswer />, path: '/faqs' },
// //   { text: 'Legal Pages', icon: <Gavel />, path: '/legal-pages' },
// //   { text: 'Recharge', icon: <CurrencyRupee />, path: '/recharge-plans' },
// //   { text: 'Complaints', icon: <Report />, path: '/complaints' },
// //   { text: 'Admin Users', icon: <SupervisorAccount />, path: '/admin-users' },
// //   { text: 'Settings', icon: <Settings />, path: '/settings' },
// // ];

// // const Layout = () => {
// //   const [mobileOpen, setMobileOpen] = useState(false);
// //   const [anchorEl, setAnchorEl] = useState(null);
// //   const [websiteManagementOpen, setWebsiteManagementOpen] = useState(false);
// //   const navigate = useNavigate();
// //   const location = useLocation();
// //   const { user, logout } = useAuth();

// //   const handleDrawerToggle = () => {
// //     setMobileOpen(!mobileOpen);
// //   };

// //   const handleProfileMenuOpen = (event) => {
// //     setAnchorEl(event.currentTarget);
// //   };

// //   const handleProfileMenuClose = () => {
// //     setAnchorEl(null);
// //   };

// //   const handleLogout = async () => {
// //     await logout();
// //     navigate('/login');
// //   };

// //   const drawer = (
// //     <Box>
// //       <Toolbar sx={{ bgcolor: 'primary.main', justifyContent: 'center' }}>
// //         <Typography variant="h5" fontWeight="bold" color="text.primary">
// //           Pushpa Admin
// //         </Typography>
// //       </Toolbar>
// //       <Divider />
// //       <List sx={{ px: 1, py: 2 }}>
// //         {menuItems.map((item) => (
// //           <ListItem key={item.text} disablePadding sx={{ mb: 0.5 }}>
// //             <ListItemButton
// //               selected={location.pathname === item.path}
// //               onClick={() => navigate(item.path)}
// //               sx={{
// //                 borderRadius: 2,
// //                 '&.Mui-selected': {
// //                   bgcolor: 'primary.main',
// //                   color: 'text.primary',
// //                   '&:hover': {
// //                     bgcolor: 'primary.dark',
// //                   },
// //                   '& .MuiListItemIcon-root': {
// //                     color: 'text.primary',
// //                   },
// //                 },
// //               }}
// //             >
// //               <ListItemIcon
// //                 sx={{
// //                   color: location.pathname === item.path ? 'text.primary' : 'text.secondary',
// //                   minWidth: 40,
// //                 }}
// //               >
// //                 {item.icon}
// //               </ListItemIcon>
// //               <ListItemText
// //                 primary={item.text}
// //                 primaryTypographyProps={{
// //                   fontSize: '0.9rem',
// //                   fontWeight: location.pathname === item.path ? 600 : 400,
// //                 }}
// //               />
// //             </ListItemButton>
// //           </ListItem>
// //         ))}

// //         {/* Website Management with Dropdown */}
// //         <ListItem disablePadding sx={{ mb: 0.5 }}>
// //           <ListItemButton
// //             onClick={() => setWebsiteManagementOpen(!websiteManagementOpen)}
// //             sx={{
// //               borderRadius: 2,
// //             }}
// //           >
// //             <ListItemIcon
// //               sx={{
// //                 color: 'text.secondary',
// //                 minWidth: 40,
// //               }}
// //             >
// //               <Language />
// //             </ListItemIcon>
// //             <ListItemText
// //               primary="Website Management"
// //               primaryTypographyProps={{
// //                 fontSize: '0.9rem',
// //                 fontWeight: 400,
// //               }}
// //             />
// //             {websiteManagementOpen ? <ExpandLess /> : <ExpandMore />}
// //           </ListItemButton>
// //         </ListItem>

// //         {/* Website Management Submenu */}
// //         {websiteManagementOpen && (
// //           <List component="div" disablePadding>
// //             <ListItem disablePadding sx={{ mb: 0.5 }}>
// //               <ListItemButton
// //                 selected={location.pathname === '/our-services'}
// //                 onClick={() => navigate('/our-services')}
// //                 sx={{
// //                   pl: 4,
// //                   borderRadius: 2,
// //                   '&.Mui-selected': {
// //                     bgcolor: 'primary.main',
// //                     color: 'text.primary',
// //                     '&:hover': {
// //                       bgcolor: 'primary.dark',
// //                     },
// //                     '& .MuiListItemIcon-root': {
// //                       color: 'text.primary',
// //                     },
// //                   },
// //                 }}
// //               >
// //                 <ListItemIcon
// //                   sx={{
// //                     color: location.pathname === '/our-services' ? 'text.primary' : 'text.secondary',
// //                     minWidth: 40,
// //                   }}
// //                 >
// //                   <Build />
// //                 </ListItemIcon>
// //                 <ListItemText
// //                   primary="Our Services"
// //                   primaryTypographyProps={{
// //                     fontSize: '0.85rem',
// //                     fontWeight: location.pathname === '/our-services' ? 600 : 400,
// //                   }}
// //                 />
// //               </ListItemButton>
// //             </ListItem>
// //           </List>
// //         )}
// //       </List>
// //     </Box>
// //   );

// //   return (
// //     <Box sx={{ display: 'flex' }}>
// //       <AppBar
// //         position="fixed"
// //         sx={{
// //           width: { sm: `calc(100% - ${drawerWidth}px)` },
// //           ml: { sm: `${drawerWidth}px` },
// //           bgcolor: 'background.paper',
// //           color: 'text.primary',
// //         }}
// //       >
// //         <Toolbar>
// //           <IconButton
// //             color="inherit"
// //             edge="start"
// //             onClick={handleDrawerToggle}
// //             sx={{ mr: 2, display: { sm: 'none' } }}
// //           >
// //             <MenuIcon />
// //           </IconButton>
// //           <Box sx={{ flexGrow: 1 }} />
// //           <IconButton onClick={handleProfileMenuOpen} sx={{ p: 0 }}>
// //             <Avatar sx={{ bgcolor: 'primary.main', color: 'text.primary' }}>
// //               {user?.name?.charAt(0).toUpperCase() || 'A'}
// //             </Avatar>
// //           </IconButton>
// //           <Menu
// //             anchorEl={anchorEl}
// //             open={Boolean(anchorEl)}
// //             onClose={handleProfileMenuClose}
// //             transformOrigin={{ horizontal: 'right', vertical: 'top' }}
// //             anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
// //           >
// //             <MenuItem disabled>
// //               <Typography variant="body2" color="text.secondary">
// //                 {user?.name || 'Admin User'}
// //               </Typography>
// //             </MenuItem>
// //             <MenuItem disabled>
// //               <Typography variant="body2" color="text.secondary">
// //                 {user?.email || 'admin@pushpa.com'}
// //               </Typography>
// //             </MenuItem>
// //             <Divider />
// //             <MenuItem onClick={handleLogout}>
// //               <ListItemIcon>
// //                 <Logout fontSize="small" />
// //               </ListItemIcon>
// //               <ListItemText>Logout</ListItemText>
// //             </MenuItem>
// //           </Menu>
// //         </Toolbar>
// //       </AppBar>
// //       <Box
// //         component="nav"
// //         sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
// //       >
// //         <Drawer
// //           variant="temporary"
// //           open={mobileOpen}
// //           onClose={handleDrawerToggle}
// //           ModalProps={{
// //             keepMounted: true,
// //           }}
// //           sx={{
// //             display: { xs: 'block', sm: 'none' },
// //             '& .MuiDrawer-paper': {
// //               boxSizing: 'border-box',
// //               width: drawerWidth,
// //             },
// //           }}
// //         >
// //           {drawer}
// //         </Drawer>
// //         <Drawer
// //           variant="permanent"
// //           sx={{
// //             display: { xs: 'none', sm: 'block' },
// //             '& .MuiDrawer-paper': {
// //               boxSizing: 'border-box',
// //               width: drawerWidth,
// //             },
// //           }}
// //           open
// //         >
// //           {drawer}
// //         </Drawer>
// //       </Box>
// //       <Box
// //         component="main"
// //         sx={{
// //           flexGrow: 1,
// //           p: 3,
// //           width: { sm: `calc(100% - ${drawerWidth}px)` },
// //           minHeight: '100vh',
// //           bgcolor: 'background.default',
// //         }}
// //       >
// //         <Toolbar />
// //         <Outlet />
// //       </Box>
// //     </Box>
// //   );
// // };

// // export default Layout;


// import React, { useState } from 'react';
// import { Outlet, useNavigate, useLocation } from 'react-router-dom';
// import {
//   Box,
//   Drawer,
//   AppBar,
//   Toolbar,
//   List,
//   Typography,
//   Divider,
//   IconButton,
//   ListItem,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
//   Avatar,
//   Menu,
//   MenuItem,
//   Collapse,
// } from '@mui/material';
// import {
//   Menu as MenuIcon,
//   Dashboard,
//   DirectionsCar,
//   People,
//   LocalTaxi,
//   VerifiedUser,
//   // Payment,
//   // MonetizationOn,
//   LocalOffer,
//   AttachMoney,
//   Notifications,
//   Assessment,
//   Warning,
//   TrackChanges,
//   Star,
//   Support,
//   Settings,
//   LocationOn,
//   Build,
//   Category,
//   Report,
//   SupervisorAccount,
//   Logout,
//   Description,
//   Cancel,
//   QuestionAnswer,
//   Gavel,
//   CurrencyRupee,
//   History,
//   ContactPhone,
//   Chat,
//   Forum,
//   Language,
//   ExpandLess,
//   ExpandMore,
// } from '@mui/icons-material';
// import { useAuth } from '../context/AuthContext';

// const drawerWidth = 260;

// // Menu configuration with sub-menu support
// const menuItems = [
//   {
//     text: 'Analytics',
//     icon: <Dashboard />,
//     children: [
//       { text: 'Dashboard', path: '/dashboard', icon: <Dashboard /> },
//       { text: 'Earnings', path: '/dashboard/earnings', icon: <AttachMoney /> },
//       { text: 'Recharge History', path: '/dashboard/recharge-history', icon: <History /> },
//     ],
//   },
//   // { text: 'Drivers', path: '/drivers', icon: <DirectionsCar /> },
//   // { text: 'Passengers', path: '/passengers', icon: <People /> },
//   { text: 'Pilot', path: '/drivers', icon: <DirectionsCar /> },
//   { text: 'Customer', path: '/passengers', icon: <People /> },
//   { text: 'Admin Users', path: '/admin-users', icon: <SupervisorAccount /> },   
//   {
//     text: 'Ride History',
//     icon: <LocalTaxi />,
//     children: [
//       { text: 'Rides', path: '/rides', icon: <LocalTaxi /> },
//       { text: 'Passenger Rides', path: '/dashboard/earnings', icon: <AttachMoney /> },
//       { text: 'Pilot Rides', path: '/dashboard/recharge-history', icon: <History /> },
//     ],
//   },
//   { text: 'Live Tracking', path: '/live-tracking', icon: <TrackChanges /> },
//   { text: 'Ratings', path: '/ratings', icon: <Star /> },
//   { text: 'Complaints', path: '/complaints', icon: <Report /> },   
//   { text: 'Verifications', path: '/verifications', icon: <VerifiedUser /> },
//   // { text: 'Manage Driver Documents', path: '/driver-documents', icon: <Description /> },
//   { text: 'Manage Pilot Documents', path: '/driver-documents', icon: <Description /> },
//   { text: 'Documents', path: '/documents', icon: <Description /> },  
//   { text: 'Pricing', path: '/pricing', icon: <AttachMoney /> },
//   { text: 'Recharge', path: '/recharge-plans', icon: <CurrencyRupee /> },
//   { text: 'Promo Codes', path: '/promo-codes', icon: <LocalOffer /> },
//   { text: 'Notifications', path: '/notifications', icon: <Notifications /> },
//   { text: 'Notification History', path: '/notification-history', icon: <History /> },
//   { text: 'FAQs', path: '/faqs', icon: <QuestionAnswer /> },
//   { text: 'Chat Conversations', path: '/chat-conversations', icon: <Forum /> },
//   { text: 'Manage Quick Chat', path: '/quick-chat', icon: <Chat /> },
//   { text: 'Support', path: '/support', icon: <Support /> },
//   { text: 'Emergency Contacts', path: '/emergency-contacts', icon: <ContactPhone /> },  
//   { text: 'Main Services', path: '/main-services', icon: <Category /> },
//   { text: 'Services', path: '/services', icon: <Build /> },
//   { text: 'Legal Pages', path: '/legal-pages', icon: <Gavel /> },  
//   { text: 'Settings', path: '/settings', icon: <Settings /> },
//   { text: 'Regions', path: '/regions', icon: <LocationOn /> },
//   { text: 'Manage Cancel Reasons', path: '/cancel-reasons', icon: <Cancel /> },
//   { text: 'Manage Ratings', path: '/rating-feedback', icon: <Star /> },  
//   { text: 'Reports', path: '/reports', icon: <Assessment /> },
//   { text: 'Emergency', path: '/emergency', icon: <Warning /> },  
//   {
//     text: 'Ratings',
//     icon: <LocalTaxi />,
//     children: [
//       { text: 'All Ratings', path: '/ratings', icon: <Star /> },
//       { text: 'Pilot Ratings', path: '/driver-ratings', icon: <Star /> },
//       { text: 'Customer Ratings', path: '/passenger-ratings', icon: <Star /> },
//     ]
//   },  
// ];

// const Layout = () => {
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [openMenus, setOpenMenus] = useState({});
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { user, logout } = useAuth();

//   const handleDrawerToggle = () => {
//     setMobileOpen(!mobileOpen);
//   };

//   const handleProfileMenuOpen = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleProfileMenuClose = () => {
//     setAnchorEl(null);
//   };

//   const handleLogout = async () => {
//     await logout();
//     navigate('/login');
//   };

//   const handleMenuToggle = (menuText) => {
//     setOpenMenus(prev => ({
//       ...prev,
//       [menuText]: !prev[menuText]
//     }));
//   };

//   // Check if any child path is active
//   const isChildActive = (children) => {
//     return children?.some(child => location.pathname === child.path);
//   };

//   // Check if menu should be open by default
//   const isMenuOpen = (menuItem) => {
//     return openMenus[menuItem.text] || isChildActive(menuItem.children);
//   };

//   // Handle navigation for items with path
//   const handleNavigation = (path) => {
//     if (path) {
//       navigate(path);
//       if (mobileOpen) handleDrawerToggle();
//     }
//   };

//   const drawer = (
//     <Box>
//       <Toolbar sx={{ bgcolor: 'primary.main', justifyContent: 'center' }}>
//         <Typography variant="h5" fontWeight="bold" color="text.primary">
//           Pushpa Admin
//         </Typography>
//       </Toolbar>
//       <Divider />
//       <List sx={{ px: 1, py: 2 }}>
//         {menuItems.map((item) => (
//           <React.Fragment key={item.text}>
//             {/* Parent Menu Item */}
//             <ListItem disablePadding sx={{ mb: 0.5 }}>
//               <ListItemButton
//                 onClick={() => {
//                   if (item.children) {
//                     handleMenuToggle(item.text);
//                   } else if (item.path) {
//                     handleNavigation(item.path);
//                   }
//                 }}
//                 sx={{
//                   borderRadius: 2,
//                   '&.Mui-selected': {
//                     bgcolor: 'primary.main',
//                     color: 'text.primary',
//                     '&:hover': {
//                       bgcolor: 'primary.dark',
//                     },
//                     '& .MuiListItemIcon-root': {
//                       color: 'text.primary',
//                     },
//                   },
//                 }}
//                 selected={item.path ? location.pathname === item.path : isChildActive(item.children)}
//               >
//                 <ListItemIcon
//                   sx={{
//                     color: (item.path ? location.pathname === item.path : isChildActive(item.children)) ? 'text.primary' : 'text.secondary',
//                     minWidth: 40,
//                   }}
//                 >
//                   {item.icon}
//                 </ListItemIcon>
//                 <ListItemText
//                   primary={item.text}
//                   primaryTypographyProps={{
//                     fontSize: '0.9rem',
//                     fontWeight: (item.path ? location.pathname === item.path : isChildActive(item.children)) ? 600 : 400,
//                   }}
//                 />
//                 {item.children && (
//                   isMenuOpen(item) ? <ExpandLess /> : <ExpandMore />
//                 )}
//               </ListItemButton>
//             </ListItem>

//             {/* Child Menu Items */}
//             {item.children && (
//               <Collapse in={isMenuOpen(item)} timeout="auto" unmountOnExit>
//                 <List component="div" disablePadding>
//                   {item.children.map((child) => (
//                     <ListItem key={child.text} disablePadding sx={{ mb: 0.5 }}>
//                       <ListItemButton
//                         selected={location.pathname === child.path}
//                         onClick={() => handleNavigation(child.path)}
//                         sx={{
//                           pl: 4,
//                           borderRadius: 2,
//                           '&.Mui-selected': {
//                             bgcolor: 'primary.main',
//                             color: 'text.primary',
//                             '&:hover': {
//                               bgcolor: 'primary.dark',
//                             },
//                             '& .MuiListItemIcon-root': {
//                               color: 'text.primary',
//                             },
//                           },
//                         }}
//                       >
//                         <ListItemIcon
//                           sx={{
//                             color: location.pathname === child.path ? 'text.primary' : 'text.secondary',
//                             minWidth: 40,
//                           }}
//                         >
//                           {child.icon}
//                         </ListItemIcon>
//                         <ListItemText
//                           primary={child.text}
//                           primaryTypographyProps={{
//                             fontSize: '0.85rem',
//                             fontWeight: location.pathname === child.path ? 600 : 400,
//                           }}
//                         />
//                       </ListItemButton>
//                     </ListItem>
//                   ))}
//                 </List>
//               </Collapse>
//             )}
//           </React.Fragment>
//         ))}

//         {/* Website Management with Dropdown */}
//         <ListItem disablePadding sx={{ mb: 0.5 }}>
//           <ListItemButton
//             onClick={() => handleMenuToggle('Website Management')}
//             sx={{
//               borderRadius: 2,
//               '&.Mui-selected': {
//                 bgcolor: 'primary.main',
//                 color: 'text.primary',
//                 '&:hover': {
//                   bgcolor: 'primary.dark',
//                 },
//                 '& .MuiListItemIcon-root': {
//                   color: 'text.primary',
//                 },
//               },
//             }}
//             selected={location.pathname === '/our-services'}
//           >
//             <ListItemIcon
//               sx={{
//                 color: location.pathname === '/our-services' ? 'text.primary' : 'text.secondary',
//                 minWidth: 40,
//               }}
//             >
//               <Language />
//             </ListItemIcon>
//             <ListItemText
//               primary="Website Management"
//               primaryTypographyProps={{
//                 fontSize: '0.9rem',
//                 fontWeight: location.pathname === '/our-services' ? 600 : 400,
//               }}
//             />
//             {openMenus['Website Management'] ? <ExpandLess /> : <ExpandMore />}
//           </ListItemButton>
//         </ListItem>

//         {/* Website Management Submenu */}
//         <Collapse in={openMenus['Website Management'] || location.pathname === '/our-services'} timeout="auto" unmountOnExit>
//           <List component="div" disablePadding>
//             <ListItem disablePadding sx={{ mb: 0.5 }}>
//               <ListItemButton
//                 selected={location.pathname === '/our-services'}
//                 onClick={() => handleNavigation('/our-services')}
//                 sx={{
//                   pl: 4,
//                   borderRadius: 2,
//                   '&.Mui-selected': {
//                     bgcolor: 'primary.main',
//                     color: 'text.primary',
//                     '&:hover': {
//                       bgcolor: 'primary.dark',
//                     },
//                     '& .MuiListItemIcon-root': {
//                       color: 'text.primary',
//                     },
//                   },
//                 }}
//               >
//                 <ListItemIcon
//                   sx={{
//                     color: location.pathname === '/our-services' ? 'text.primary' : 'text.secondary',
//                     minWidth: 40,
//                   }}
//                 >
//                   <Build />
//                 </ListItemIcon>
//                 <ListItemText
//                   primary="Our Services"
//                   primaryTypographyProps={{
//                     fontSize: '0.85rem',
//                     fontWeight: location.pathname === '/our-services' ? 600 : 400,
//                   }}
//                 />
//               </ListItemButton>
//             </ListItem>
//           </List>
//         </Collapse>
//       </List>
//     </Box>
//   );

//   return (
//     <Box sx={{ display: 'flex' }}>
//       <AppBar
//         position="fixed"
//         sx={{
//           width: { sm: `calc(100% - ${drawerWidth}px)` },
//           ml: { sm: `${drawerWidth}px` },
//           bgcolor: 'background.paper',
//           color: 'text.primary',
//         }}
//       >
//         <Toolbar>
//           <IconButton
//             color="inherit"
//             edge="start"
//             onClick={handleDrawerToggle}
//             sx={{ mr: 2, display: { sm: 'none' } }}
//           >
//             <MenuIcon />
//           </IconButton>
//           <Box sx={{ flexGrow: 1 }} />
//           <IconButton onClick={handleProfileMenuOpen} sx={{ p: 0 }}>
//             <Avatar sx={{ bgcolor: 'primary.main', color: 'text.primary' }}>
//               {user?.name?.charAt(0).toUpperCase() || 'A'}
//             </Avatar>
//           </IconButton>
//           <Menu
//             anchorEl={anchorEl}
//             open={Boolean(anchorEl)}
//             onClose={handleProfileMenuClose}
//             transformOrigin={{ horizontal: 'right', vertical: 'top' }}
//             anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
//           >
//             <MenuItem disabled>
//               <Typography variant="body2" color="text.secondary">
//                 {user?.name || 'Admin User'}
//               </Typography>
//             </MenuItem>
//             <MenuItem disabled>
//               <Typography variant="body2" color="text.secondary">
//                 {user?.email || 'admin@pushpa.com'}
//               </Typography>
//             </MenuItem>
//             <Divider />
//             <MenuItem onClick={handleLogout}>
//               <ListItemIcon>
//                 <Logout fontSize="small" />
//               </ListItemIcon>
//               <ListItemText>Logout</ListItemText>
//             </MenuItem>
//           </Menu>
//         </Toolbar>
//       </AppBar>
//       <Box
//         component="nav"
//         sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
//       >
//         <Drawer
//           variant="temporary"
//           open={mobileOpen}
//           onClose={handleDrawerToggle}
//           ModalProps={{
//             keepMounted: true,
//           }}
//           sx={{
//             display: { xs: 'block', sm: 'none' },
//             '& .MuiDrawer-paper': {
//               boxSizing: 'border-box',
//               width: drawerWidth,
//             },
//           }}
//         >
//           {drawer}
//         </Drawer>
//         <Drawer
//           variant="permanent"
//           sx={{
//             display: { xs: 'none', sm: 'block' },
//             '& .MuiDrawer-paper': {
//               boxSizing: 'border-box',
//               width: drawerWidth,
//             },
//           }}
//           open
//         >
//           {drawer}
//         </Drawer>
//       </Box>
//       <Box
//         component="main"
//         sx={{
//           flexGrow: 1,
//           p: 3,
//           width: { sm: `calc(100% - ${drawerWidth}px)` },
//           minHeight: '100vh',
//           bgcolor: 'background.default',
//         }}
//       >
//         <Toolbar />
//         <Outlet />
//       </Box>
//     </Box>
//   );
// };

// export default Layout;

// Layout.js (updated with role-based access)
import React, { useState, useMemo } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import {
  Box,
  Drawer,
  AppBar,
  Toolbar,
  List,
  Typography,
  Divider,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Avatar,
  Menu,
  MenuItem,
  Collapse,
} from '@mui/material';
import {
  Menu as MenuIcon,
  Dashboard,
  DirectionsCar,
  People,
  LocalTaxi,
  VerifiedUser,
  LocalOffer,
  AttachMoney,
  Notifications,
  Assessment,
  Warning,
  TrackChanges,
  Star,
  Support,
  Settings,
  LocationOn,
  Build,
  Category,
  Report,
  SupervisorAccount,
  Logout,
  Description,
  Cancel,
  QuestionAnswer,
  Gavel,
  CurrencyRupee,
  History,
  ContactPhone,
  Chat,
  Forum,
  Language,
  ExpandLess,
  ExpandMore,
} from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';

const drawerWidth = 260;

// Define menu items with role restrictions
const ALL_ROLES = ['super_admin', 'taxi_attachment'];
const ADMIN_ONLY = ['super_admin'];
const TAXI_ATTACHMENT_ONLY = ['taxi_attachment'];

// Menu configuration with role-based access
const menuConfig = [
  { 
    text: 'Dashboard', 
    path: '/v2/', 
    icon: <Dashboard /> 
  },
  {
    text: 'Analytics',
    icon: <Dashboard />,
    roles: ADMIN_ONLY,
    children: [
      { text: 'Dashboard', path: '/dashboard', icon: <Dashboard />, roles: ADMIN_ONLY },
      { text: 'Earnings', path: '/dashboard/earnings', icon: <AttachMoney />, roles: ADMIN_ONLY },
      { text: 'Recharge History', path: '/dashboard/recharge-history', icon: <History />, roles: ADMIN_ONLY },
    ],
  },
  {
    text: 'Taxi Attachment Analytics',
    icon: <Dashboard />,
    roles: TAXI_ATTACHMENT_ONLY,
    children: [
      { text: 'Dashboard', path: '/dashboard/taxi-attachment', icon: <Dashboard />, roles: TAXI_ATTACHMENT_ONLY },      
    ],
  },
  { 
    text: 'Pilot', 
    path: '/drivers', 
    icon: <DirectionsCar />, 
    roles: ALL_ROLES 
  },
  { 
    text: 'Customer', 
    path: '/passengers', 
    icon: <People />, 
    roles: ADMIN_ONLY 
  },
  { 
    text: 'Admin Users', 
    path: '/admin-users', 
    icon: <SupervisorAccount />, 
    roles: ADMIN_ONLY 
  },
  {
    text: 'Ride History',
    icon: <LocalTaxi />,
    roles: ADMIN_ONLY,
    children: [
      { text: 'Rides', path: '/rides', icon: <LocalTaxi />, roles: ADMIN_ONLY },
      { text: 'Customer Rides', path: '/passenger-rides', icon: <People />, roles: ADMIN_ONLY },
      { text: 'Pilot Rides', path: '/driver-rides', icon: <DirectionsCar />, roles: ADMIN_ONLY },
    ],
  },
  { 
    text: 'Live Tracking', 
    path: '/live-tracking', 
    icon: <TrackChanges />, 
    roles: ADMIN_ONLY 
  },
  { 
    text: 'Ratings', 
    path: '/ratings', 
    icon: <Star />, 
    roles: ADMIN_ONLY 
  },
  { 
    text: 'Complaints', 
    path: '/complaints', 
    icon: <Report />, 
    roles: ADMIN_ONLY 
  },
  { 
    text: 'Verifications', 
    path: '/verifications', 
    icon: <VerifiedUser />, 
    roles: ALL_ROLES, 
  },
  { 
    text: 'Manage Pilot Documents', 
    path: '/driver-documents', 
    icon: <Description />, 
    roles: ALL_ROLES,
  },
  { 
    text: 'Documents', 
    path: '/documents', 
    icon: <Description />, 
   roles: ALL_ROLES, 
  },
  { 
    text: 'Pricing', 
    path: '/pricing', 
    icon: <AttachMoney />, 
    roles: ADMIN_ONLY 
  },
  { 
    text: 'Recharge', 
    path: '/recharge-plans', 
    icon: <CurrencyRupee />, 
    roles: ADMIN_ONLY 
  },
  { 
    text: 'Promo Codes', 
    path: '/promo-codes', 
    icon: <LocalOffer />, 
    roles: ADMIN_ONLY 
  },
  { 
    text: 'Notifications', 
    path: '/notifications', 
    icon: <Notifications />, 
    roles: ADMIN_ONLY 
  },
  { 
    text: 'Notification History', 
    path: '/notification-history', 
    icon: <History />, 
    roles: ADMIN_ONLY 
  },
  { 
    text: 'FAQs', 
    path: '/faqs', 
    icon: <QuestionAnswer />, 
    roles: ADMIN_ONLY 
  },
  { 
    text: 'Chat Conversations', 
    path: '/chat-conversations', 
    icon: <Forum />, 
    roles: ADMIN_ONLY 
  },
  { 
    text: 'Manage Quick Chat', 
    path: '/quick-chat', 
    icon: <Chat />, 
    roles: ADMIN_ONLY 
  },
  { 
    text: 'Support', 
    path: '/support', 
    icon: <Support />, 
    roles: ADMIN_ONLY 
  },
  { 
    text: 'Emergency Contacts', 
    path: '/emergency-contacts', 
    icon: <ContactPhone />, 
    roles: ADMIN_ONLY 
  },
  { 
    text: 'Main Services', 
    path: '/main-services', 
    icon: <Category />, 
    roles: ADMIN_ONLY 
  },
  { 
    text: 'Services', 
    path: '/services', 
    icon: <Build />, 
    roles: ADMIN_ONLY 
  },
  { 
    text: 'Legal Pages', 
    path: '/legal-pages', 
    icon: <Gavel />, 
    roles: ADMIN_ONLY 
  },
  { 
    text: 'Settings', 
    path: '/settings', 
    icon: <Settings />, 
    roles: ADMIN_ONLY 
  },
  { 
    text: 'Regions', 
    path: '/regions', 
    icon: <LocationOn />, 
    roles: ADMIN_ONLY 
  },
  { 
    text: 'Manage Cancel Reasons', 
    path: '/cancel-reasons', 
    icon: <Cancel />, 
    roles: ADMIN_ONLY 
  },
  { 
    text: 'Manage Ratings', 
    path: '/rating-feedback', 
    icon: <Star />, 
    roles: ADMIN_ONLY 
  },
  { 
    text: 'Reports', 
    path: '/reports', 
    icon: <Assessment />, 
    roles: ADMIN_ONLY 
  },
  { 
    text: 'Emergency', 
    path: '/emergency', 
    icon: <Warning />, 
    roles: ADMIN_ONLY 
  },
];

// Website Management submenu with role restrictions
const websiteManagementConfig = {
  text: 'Website Management',
  icon: <Language />,
  roles: ADMIN_ONLY,
  children: [
    { text: 'Our Services', path: '/our-services', icon: <Build />, roles: ADMIN_ONLY },
  ],
};

const Layout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openMenus, setOpenMenus] = useState({});
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  // Filter menu items based on user role
  const filteredMenuItems = useMemo(() => {
    if (!user) return [];
    
    const userRole = user.role;
    const isAdmin = userRole === 'admin';
    
    const filterItems = (items) => {
      return items
        .filter(item => {
          // Check if user has access to this item
          if (!item.roles) return true;
          if (isAdmin) return true; // Admin can see everything
          return item.roles.includes(userRole);
        })
        .map(item => {
          if (item.children) {
            // Filter children based on role
            const filteredChildren = item.children.filter(child => {
              if (!child.roles) return true;
              if (isAdmin) return true;
              return child.roles.includes(userRole);
            });
            return { ...item, children: filteredChildren };
          }
          return item;
        })
        .filter(item => {
          // Remove parent items that have no visible children after filtering
          if (item.children) {
            return item.children.length > 0;
          }
          return true;
        });
    };

    return filterItems(menuConfig);
  }, [user]);

  // Check if user has access to website management
  const canAccessWebsiteManagement = useMemo(() => {
    if (!user) return false;
    if (user.role === 'admin') return true;
    return websiteManagementConfig.roles.includes(user.role);
  }, [user]);

  // Filter website management children based on role
  const filteredWebsiteChildren = useMemo(() => {
    if (!user) return [];
    const isAdmin = user.role === 'admin';
    return websiteManagementConfig.children.filter(child => {
      if (!child.roles) return true;
      if (isAdmin) return true;
      return child.roles.includes(user.role);
    });
  }, [user]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleProfileMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const handleMenuToggle = (menuText) => {
    setOpenMenus(prev => ({
      ...prev,
      [menuText]: !prev[menuText]
    }));
  };

  // Check if any child path is active
  const isChildActive = (children) => {
    return children?.some(child => location.pathname === child.path);
  };

  // Check if menu should be open by default
  const isMenuOpen = (menuItem) => {
    return openMenus[menuItem.text] || isChildActive(menuItem.children);
  };

  // Handle navigation for items with path
  const handleNavigation = (path) => {
    if (path) {
      navigate(path);
      if (mobileOpen) handleDrawerToggle();
    }
  };

  const drawer = (
    <Box>
      <Toolbar sx={{ bgcolor: 'primary.main', justifyContent: 'center' }}>
        <Typography variant="h5" fontWeight="bold" color="text.primary">
          Pushpa Admin
        </Typography>
        {user && (
          <Typography variant="caption" sx={{ ml: 1, color: 'text.secondary' }}>
            ({user.role === 'super_admin' ? 'Super Admin' : 'Taxi Attachment'})
          </Typography>
        )}
      </Toolbar>
      <Divider />
      <List sx={{ px: 1, py: 2 }}>
        {filteredMenuItems.map((item) => (
          <React.Fragment key={item.text}>
            {/* Parent Menu Item */}
            <ListItem disablePadding sx={{ mb: 0.5 }}>
              <ListItemButton
                onClick={() => {
                  if (item.children) {
                    handleMenuToggle(item.text);
                  } else if (item.path) {
                    handleNavigation(item.path);
                  }
                }}
                sx={{
                  borderRadius: 2,
                  '&.Mui-selected': {
                    bgcolor: 'primary.main',
                    color: 'text.primary',
                    '&:hover': {
                      bgcolor: 'primary.dark',
                    },
                    '& .MuiListItemIcon-root': {
                      color: 'text.primary',
                    },
                  },
                }}
                selected={item.path ? location.pathname === item.path : isChildActive(item.children)}
              >
                <ListItemIcon
                  sx={{
                    color: (item.path ? location.pathname === item.path : isChildActive(item.children)) ? 'text.primary' : 'text.secondary',
                    minWidth: 40,
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                <ListItemText
                  primary={item.text}
                  primaryTypographyProps={{
                    fontSize: '0.9rem',
                    fontWeight: (item.path ? location.pathname === item.path : isChildActive(item.children)) ? 600 : 400,
                  }}
                />
                {item.children && (
                  isMenuOpen(item) ? <ExpandLess /> : <ExpandMore />
                )}
              </ListItemButton>
            </ListItem>

            {/* Child Menu Items */}
            {item.children && (
              <Collapse in={isMenuOpen(item)} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {item.children.map((child) => (
                    <ListItem key={child.text} disablePadding sx={{ mb: 0.5 }}>
                      <ListItemButton
                        selected={location.pathname === child.path}
                        onClick={() => handleNavigation(child.path)}
                        sx={{
                          pl: 4,
                          borderRadius: 2,
                          '&.Mui-selected': {
                            bgcolor: 'primary.main',
                            color: 'text.primary',
                            '&:hover': {
                              bgcolor: 'primary.dark',
                            },
                            '& .MuiListItemIcon-root': {
                              color: 'text.primary',
                            },
                          },
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            color: location.pathname === child.path ? 'text.primary' : 'text.secondary',
                            minWidth: 40,
                          }}
                        >
                          {child.icon}
                        </ListItemIcon>
                        <ListItemText
                          primary={child.text}
                          primaryTypographyProps={{
                            fontSize: '0.85rem',
                            fontWeight: location.pathname === child.path ? 600 : 400,
                          }}
                        />
                      </ListItemButton>
                    </ListItem>
                  ))}
                </List>
              </Collapse>
            )}
          </React.Fragment>
        ))}

        {/* Website Management with Dropdown - Only show if user has access */}
        {canAccessWebsiteManagement && filteredWebsiteChildren.length > 0 && (
          <>
            <ListItem disablePadding sx={{ mb: 0.5 }}>
              <ListItemButton
                onClick={() => handleMenuToggle('Website Management')}
                sx={{
                  borderRadius: 2,
                  '&.Mui-selected': {
                    bgcolor: 'primary.main',
                    color: 'text.primary',
                    '&:hover': {
                      bgcolor: 'primary.dark',
                    },
                    '& .MuiListItemIcon-root': {
                      color: 'text.primary',
                    },
                  },
                }}
                selected={location.pathname === '/our-services'}
              >
                <ListItemIcon
                  sx={{
                    color: location.pathname === '/our-services' ? 'text.primary' : 'text.secondary',
                    minWidth: 40,
                  }}
                >
                  <Language />
                </ListItemIcon>
                <ListItemText
                  primary="Website Management"
                  primaryTypographyProps={{
                    fontSize: '0.9rem',
                    fontWeight: location.pathname === '/our-services' ? 600 : 400,
                  }}
                />
                {openMenus['Website Management'] ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
            </ListItem>

            {/* Website Management Submenu */}
            <Collapse in={openMenus['Website Management'] || location.pathname === '/our-services'} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {filteredWebsiteChildren.map((child) => (
                  <ListItem key={child.text} disablePadding sx={{ mb: 0.5 }}>
                    <ListItemButton
                      selected={location.pathname === child.path}
                      onClick={() => handleNavigation(child.path)}
                      sx={{
                        pl: 4,
                        borderRadius: 2,
                        '&.Mui-selected': {
                          bgcolor: 'primary.main',
                          color: 'text.primary',
                          '&:hover': {
                            bgcolor: 'primary.dark',
                          },
                          '& .MuiListItemIcon-root': {
                            color: 'text.primary',
                          },
                        },
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          color: location.pathname === child.path ? 'text.primary' : 'text.secondary',
                          minWidth: 40,
                        }}
                      >
                        {child.icon}
                      </ListItemIcon>
                      <ListItemText
                        primary={child.text}
                        primaryTypographyProps={{
                          fontSize: '0.85rem',
                          fontWeight: location.pathname === child.path ? 600 : 400,
                        }}
                      />
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>
            </Collapse>
          </>
        )}
      </List>
    </Box>
  );

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
          bgcolor: 'background.paper',
          color: 'text.primary',
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Box sx={{ flexGrow: 1 }} />
          <IconButton onClick={handleProfileMenuOpen} sx={{ p: 0 }}>
            <Avatar sx={{ bgcolor: 'primary.main', color: 'text.primary' }}>
              {user?.name?.charAt(0).toUpperCase() || 'A'}
            </Avatar>
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleProfileMenuClose}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          >
            <MenuItem disabled>
              <Typography variant="body2" color="text.secondary">
                {user?.name || 'Admin User'}
              </Typography>
            </MenuItem>
            <MenuItem disabled>
              <Typography variant="body2" color="text.secondary">
                {user?.email || 'admin@pushpa.com'}
              </Typography>
            </MenuItem>
            <MenuItem disabled>
              <Typography variant="body2" color="text.secondary">
                Role: {user?.role === 'super_admin' ? 'Administrator' : 'Taxi Attachment'}
              </Typography>
            </MenuItem>
            <Divider />
            <MenuItem onClick={handleLogout}>
              <ListItemIcon>
                <Logout fontSize="small" />
              </ListItemIcon>
              <ListItemText>Logout</ListItemText>
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
      >
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          minHeight: '100vh',
          bgcolor: 'background.default',
        }}
      >
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
};

export default Layout;